import IconComponent from "icons/IconComponent";

import AppLogoIcon from "./app-logo.svg";

export default (AppLogoIcon as any) as IconComponent;
